<template>
  <div class="yh_detail_bd">
    <p class="crumbs">
      <span>您的位置 : 
      <router-link to="/Index">首页</router-link> > 
      <span @click="$router.back(-1)" class="pointer">{{currentPos}}</span> > 
      <a>在线阅读</a></span>
    </p>
    <div class="details_main_box">
      <h4 class="fond">
        
        <p class="right txt_right">
          <span class="pointer" style="margin-left: 30px">
            <a v-if="isFile" :href="artical.fileUrl" :download="artical.fileUrl">
              <i class="yh-icon--"></i>下载
            </a>
          </span>
        </p>
        <div class="txt_center right">{{artical.title}}</div>
      </h4>
      <section class="read_content">
          <iframe v-if="isFile" :src="artical.fileUrl" width="1000" height="900" scroll="no"></iframe>
      <div
        v-if="!isFile"
        style="width:1000px;height:120px;padding:25px;text-align:center;background:#fff;border:1px solid #ddd"
      >
        <p style="font-size:14px;color:#999;text-align:center;margin-top:20px;">文章暂不存在</p>
      </div>
      </section>
    </div>
  </div>
</template>

<script>
import { 
  fn_toStrings
} from "../../static/js/reading.js";
export default { 
  data () {
    return {
      isFile: false,
      artical: {},
      //if_fond: false,
      content: "",
      //if_big: false,
      currentPos:"",
      right: {
        right: "20px"
      },
      font_size: {
        fontSize: "14px"
      }
    } 
  },
  methods: {
    getTypeName(val) {
      switch (val) {
      case "1":
        return '评奖成果库'
      case "2":
        return '北京研究'
      case "3":
        return '大运河文化'
      case "4":
      return '基金成果库'
      case "5":
      return '期刊库'
      case "6":
      return '课题成果库'
      case "7":
      return '京津翼研究'
      case "8":
      return '年鉴库'
      default:
        return ''
    }},
    load_article() {
      debugger
      let article = sessionStorage.getItem("article")
      this.artical = JSON.parse(article)
      if(this.artical.fileUrl.indexOf("null") === -1){
        this.isFile = true
      }
      else{
        this.isFile = false
      }
    }
    // fond_fn() {
    //   this.if_fond = !this.if_fond;
    // },
    // big_fn() {
    //   this.if_big = true;
    //   this.right.right = 20 + "px";
    // },
    // small_fn() {
    //   this.if_big = false;
    //   this.right.right = (document.documentElement.clientWidth - 1000) / 2 + 20 + "px";
    // },
    // font_size_fn(n) {
    //   let size =  parseInt( this.font_size.fontSize );
    //   if(size <= 30 && size >= 14){
    //     if(size == 30 && n > 0){
    //       this.font_size.fontSize = 30 + "px";
    //     }else if(size == 14 && n < 0){
    //       this.font_size.fontSize = 14 + "px";
    //     }else{
    //       this.font_size.fontSize = size + n + "px";
    //     }
    //   }
      
      
    //}
  },
  mounted() {
    debugger;
    this.right.right = (document.documentElement.clientWidth - 1000) / 2 + 20 + "px";
    this.currentPos = this.getTypeName(sessionStorage.getItem("articleType"))
    this.load_article()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url("../assets/css/readOnLine");
</style>



// WEBPACK FOOTER //
// src/components/readOnLine.vue